import React from "react";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@material-ui/icons";
import { getTravelStations } from "./cruds";

const TicketCardDetails = (props) => {
  const [stations, setStations] = React.useState(null);
  const [collapsed, setCollapsed] = React.useState(false);

  return (
    <div
      className="w-100"
      style={{ width: "100%", display: props.display ? "block" : "none" }}
    >
      <div className="line mx-auto" style={{ width: "98%" }}></div>
      <div className="d-flex my-5 container">
        <div className="col-sm-6 d-block">
          <div className="d-flex" style={{ gap: 10 }}>
            <div className="d-flex flex-column justify-content-between">
              <h4 style={{ fontSize: "20px" }}>
                <b>{props.departureDatetime}</b>
              </h4>
              <h4 style={{ fontSize: "20px" }}>
                <b>{props.arrivedTime}</b>
              </h4>
            </div>
            <div>
              <i className="far fa-circle" style={{ color: "darkgray" }}>
                <div
                  className="connect-line h-auto"
                  style={{
                    marginInline: "7px",
                    minHeight: "6.5rem",
                    borderRight: "1px solid darkgray",
                  }}
                ></div>
                <i className="fa fa-circle" style={{ color: "darkgray" }}></i>
              </i>
            </div>
            <div className="d-flex flex-column justify-content-between">
              <h4>
                <b>{props.directionSourceTitle}</b>
              </h4>
              <h6
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setCollapsed(!collapsed);
                  if (!stations) {
                    const params = { travelId: props.travelId };
                    getTravelStations(params).then((res) => {
                      setStations(res.data.data);
                    });
                  }
                }}
                style={{ fontSize: "14px", color: "#ffab50" }}
              >
                <span>ایستگاه ۲</span>
                {collapsed ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
              </h6>
              <h2 className="d-flex flex-column">
                {stations && collapsed
                  ? stations.map((el, idx) => {
                      if (idx === 0 || idx === stations.length - 1) {
                        return false;
                      } else {
                        return <span className="my-1">{el.stationTitle}</span>;
                      }
                    })
                  : null}
              </h2>
              <h4>
                <b>{props.directionDestTitle}</b>
              </h4>
            </div>
          </div>

          <div className="d-flex"></div>
        </div>
        <div
          className="col-sm-6 d-flex"
          style={{ alignItems: "baseline", justifyContent: "flex-end" }}
        >
          {/* <div
            className="d-flex  dg1-border p-4 w-auto"
            style={{ gap: 10, borderRadius: 20, marginTop: "-13px" }}
          >
            <img src={toAbsoluteUrl("/media/ebusCardLogos/Group 62.png")} />
            <img src={toAbsoluteUrl("/media/ebusCardLogos/Group 63.png")} />
            <img src={toAbsoluteUrl("/media/ebusCardLogos/Group 64.png")} />
          </div> */}
        </div>
      </div>
      {/* <div
        className="w-100 d-flex align-items-center"
        style={{
          borderTop: "1px dashed gray",
          borderBottom: "1px dashed gray",
          height: 50,
          opacity: "0.4",
        }}
      >
        <CompareArrows style={{ width: 40, height: 40 }} />
        <h4 className="ml-5">
          <b>مدت تعویض:</b> ۳۰دقیقه
        </h4>
      </div>
      <div className="row my-5">
        <div className="col-sm-6 d-block">
          <div className="d-flex" style={{ gap: 10 }}>
            <div className="d-flex flex-column justify-content-between">
              <h4>
                <b>10:00</b>
              </h4>
              <h4>
                <b>10:00</b>
              </h4>
            </div>
            <div>
              <i className="fa fa-circle" style={{ color: "gray" }}>
                <div
                  className="connect-line"
                  style={{ marginRight: 6.5 }}
                ></div>
                <i className="fa fa-circle" style={{ color: "black" }}></i>
              </i>
            </div>
            <div className="d-flex flex-column justify-content-between">
              <h4>
                <b>ترمینال غرب اردبیل</b>
              </h4>
              <h6 className="text-danger">
                <span>ایستگاه ۲</span>
                <KeyboardArrowUp />
              </h6>
              <p>عوارضی قزوین-</p>
              <p>عوارضی قزوین</p>
              <h4>
                <b>ترمینال غرب اردبیل</b>
              </h4>
            </div>
          </div>

          <div className="d-flex"></div>
        </div>
        <div
          className="col-sm-6 d-flex"
          style={{ alignItems: "baseline", justifyContent: "flex-end" }}
        >
          <div
            className="d-flex rounded border border-secondary p-2 w-auto h-auto"
            style={{ gap: 10 }}
          >
            <img src={toAbsoluteUrl("/media/ebusCardLogos/Group 62.png")} />
            <img src={toAbsoluteUrl("/media/ebusCardLogos/Group 63.png")} />
            <img src={toAbsoluteUrl("/media/ebusCardLogos/Group 64.png")} />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default TicketCardDetails;
